import { useMutation, useQueryClient } from '@tanstack/react-query';

import patchUpdateGiveawayMain from 'Api/brief-live/patchUpdateGiveawayMain';
import { useToast } from 'Store/toast';

const usePatchUpdateGiveawayMain = ({ onSuccess } = {}) => {
  const queryClient = useQueryClient();
  const { onOpenToast } = useToast();

  return useMutation({
    mutationKey: ['patch-update-giveaway-main'],
    mutationFn: async ({ id, payload }) => {
      return await patchUpdateGiveawayMain(id, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['giveaway-by-id'] });
      onOpenToast({
        status: 'success',
        title: 'Success',
        description: 'Giveaway berhasil diperbarui!',
        duration: 5,
        alwaysShow: false,
      });
      onSuccess?.();
    },
  });
};

export default usePatchUpdateGiveawayMain;
